"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PulseInsightDiscoveredEvent {
    constructor(id, characterization, markup, question, score, type, version) {
        this._id = id;
        this._characterization = characterization;
        this._markup = markup;
        this._question = question;
        this._score = score;
        this._type = type;
        this._version = version;
    }
    get id() {
        return this._id;
    }
    get characterization() {
        return this._characterization;
    }
    get markup() {
        return this._markup;
    }
    get question() {
        return this._question;
    }
    get score() {
        return this._score;
    }
    get type() {
        return this._type;
    }
    get version() {
        return this._version;
    }
}
exports.PulseInsightDiscoveredEvent = PulseInsightDiscoveredEvent;
//# sourceMappingURL=PulseInsightDiscoveredEvent.js.map